export default "__VITE_ASSET__Da2DPHl8__"